import React, { useState } from 'react'
import { urlSet, urlRemove } from './../../../../../Utils/URL'
import SearchAndFilters from './../../../../../Components/FilterAndPaginationComponent/SearchAndFilters'

/**
 * A copy of the the SearchAndFilters component with some custom behaviour
 * around adding codes to the auto complete options. Keeps the URL in sync.
 */
const SearchAndFiltersWithCodeAutoComplete = props => {
  var { selectedTags, onSelectedTagsChange } = props
  var [searchedCodes, setSearchedCodes] = useState([])

  /**
   * Handles when the search input changes, not the same as when a search
   * is triggered. Then sets the auto complete codes.
   * @param {string} str
   */
  const searchHandleInputChange = async str => {
    // This commented out code searches the API for codes
    /*var codes = await searchCodes(str, {
      cityId: props.cityId, 
    })*/
    var codes = props.allCodes.filter(
      code => code.slice(0, str.length).toLowerCase() == str.toLowerCase(),
    )
    setSearchedCodes(codes)
  }

  /**
   * When this method is fired it means a custom tag was auto completed which
   * will be a search tag, so it updates the URL and fires the parent method.
   * @param {string} tag
   */
  const searchOnAddTag = tag => {
    let selectedTagsCopy = []
    if (Array.isArray(selectedTags)) selectedTagsCopy = [...selectedTags]
    selectedTagsCopy.push(tag)
    onSelectedTagsChange(selectedTagsCopy)
    urlSet('tag', selectedTagsCopy)
  }

  /**
   * Fired when a custom code search tag is removed.
   * @param {string} tag
   */
  const searchOnRemoveTag = tag => {
    let selectedTagsCopy = [...selectedTags]
    var index = selectedTagsCopy.indexOf(tag)
    selectedTagsCopy.splice(index, 1)
    if (!selectedTagsCopy.length) selectedTagsCopy = null
    onSelectedTagsChange(selectedTagsCopy)
    if (selectedTagsCopy == null) urlRemove('tag')
    else urlSet('tag', selectedTagsCopy)
  }

  return (
    <SearchAndFilters
      {...props}
      enableFilterSuggestions={true}
      enableMultiFilterValues={true}
      searchSuggestions={(() => {
        if (!selectedTags) return searchedCodes
        // Removed any selected codes
        searchedCodes = searchedCodes.slice(0)
        for (var i = searchedCodes.length - 1; i >= 0; i--) {
          selectedTags.forEach(selectedCode => {
            if (searchedCodes[i] == selectedCode) searchedCodes.splice(i, 1)
          })
        }
        return searchedCodes
      })()}
      searchTags={selectedTags}
      searchHandleInputChange={searchHandleInputChange}
      searchOnAddTag={searchOnAddTag}
      searchOnRemoveTag={searchOnRemoveTag}
      searchedCodes={searchedCodes}
    />
  )
}

export default SearchAndFiltersWithCodeAutoComplete

// Turns out we don't need to search the codes on the API again, we already
// have all the details.
/*const searchCodes = async (searchString, args) => {
  var apiKey = await authorization.getAPIKey()
  var response = await getPickupInventoryData(apiKey, 50, null, {
    ...args,
    searchText: searchString,
    searchFromStart: true,
    typeId: 3, // Only flyer codes
    includeLeftovers: false,
    current: true,
    active: true,
    includeLeftovers: false,
  })
  var result = await response.json()
  var codes = result.data.inventoryItems.edges.map(edge => edge.node.description)
  return codes
}*/



// WEBPACK FOOTER //
// ./src/Containers/Form/City/Pickup/new/SearchAndFiltersWithCodeAutoComplete.js